import { Button, DialogContent, DialogTitle, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { KeyboardPaddingBottom } from 'utils/styles.utils';

import { VALIDATIONS } from 'constants/validation.constants';

import FormTextField from 'components/@forms/FormTextField';

interface Props {
  isLoadingEmailLink: boolean;
}

const EmailLink = ({ isLoadingEmailLink }: Props) => {
  const intl = useIntl();

  return (
    <>
      <DialogTitle>
        <FormattedMessage id="form.label.email" />
      </DialogTitle>
      <DialogContent sx={KeyboardPaddingBottom}>
        <Typography
          variant="body2"
          sx={{
            mb: 1,
          }}
        >
          <FormattedMessage id="account.email.link.email.description" />
        </Typography>
        <FormTextField
          name="emailAddress"
          inputMode="email"
          type="email"
          label={intl.formatMessage({ id: 'form.label.email' })}
          rules={{
            required: intl.formatMessage(
              { id: 'form.validation.required' },
              {
                label: intl.formatMessage({ id: 'form.label.email' }),
              },
            ),
            pattern: {
              value: VALIDATIONS.email,
              message: intl.formatMessage({
                id: 'form.validation.email.format',
              }),
            },
          }}
        />
        <Button
          variant="outlined"
          color="secondary"
          type="submit"
          loading={isLoadingEmailLink}
          sx={{ width: { xs: '100%', md: 'fit-content' }, mt: 2 }}
        >
          <FormattedMessage id="account.email.sign.in.label" />
        </Button>
      </DialogContent>
    </>
  );
};

export default EmailLink;
